"use client";

import { useClientGatewayAuth } from "@miadvg/auth-gateway/next-client";
import { useEffect, useRef } from "react";

import {
  clearClientSessionHintCookie,
  setClientSessionHintCookie,
} from "@/lib/client-session-hint";

/** Keeps the unsigned session-hint cookie aligned with client gateway auth state. */
export function ClientSessionHintSync() {
  const { status } = useClientGatewayAuth();
  const previous = useRef(status);

  useEffect(() => {
    if (previous.current === status) {
      return;
    }
    previous.current = status;
    if (status === "signed_in") {
      void setClientSessionHintCookie();
      return;
    }
    if (status === "signed_out") {
      clearClientSessionHintCookie();
    }
  }, [status]);

  return null;
}
